// ============================================
// CENTROCONTROL.JS — Panel tipo aeropuerto
// 2 pantallas rotatorias: Servicios del día + Estado del equipo
// ============================================

import React, { useState, useEffect, useRef } from 'react';
import { BadgeFolio } from './utils/folios';

const PP = "'Poppins', sans-serif";

const estatusCfg = {
  'En camino':     { color: '#f4a261', label: 'En camino' },
  'En sitio':      { color: '#5cd4b0', label: 'En sitio' },
  'Completado':    { color: '#a8d96a', label: 'Completado' },
  'Inconcluso':    { color: '#e05c5c', label: 'Inconcluso' },
  'No atendido':   { color: '#ff3b3b', label: 'No atendido' },
  'Programado':    { color: '#8fb8e8', label: 'Programado' },
  'Retrasado':     { color: '#f59e0b', label: 'Retrasado' },
};

const tecnicos = [
  { id: 1, nombre: 'Miguel García', ini: 'MG', color: '#5c9adb' },
  { id: 2, nombre: 'Pedro Ramírez', ini: 'PR', color: '#5cd4b0' },
  { id: 3, nombre: 'Omar López', ini: 'OL', color: '#f4a261' },
  { id: 4, nombre: 'Carlos Vega', ini: 'CV', color: '#e07bbd' },
  { id: 5, nombre: 'Daniel Soto', ini: 'DS', color: '#a78bfa' },
  { id: 6, nombre: 'Andrés Mora', ini: 'AM', color: '#34d399' },
  { id: 7, nombre: 'Luis Torres', ini: 'LT', color: '#8fb8e8' },
  { id: 8, nombre: 'Raúl Jiménez', ini: 'RJ', color: '#a8d96a' },
  { id: 9, nombre: 'Felipe Cruz', ini: 'FC', color: '#e05c5c' },
  { id: 10, nombre: 'Jorge Medina', ini: 'JM', color: '#dcde74' },
  { id: 11, nombre: 'Arturo Ríos', ini: 'AR', color: '#2f5f9e' },
  { id: 12, nombre: 'Martín Herrera', ini: 'MH', color: '#9a3412' },
];

const tipoIcon = { 'Instalación': '🔧', 'Mantenimiento': '⚙️', 'Visita': '📋', 'Urgencia': '⚠️', 'Externo': '🏢' };

const serviciosHoy = [
  { id: 1, folio: 'SRV-2026-001', tipo: 'Instalación', cliente: 'Bodegas Alianza', sucursal: 'Bodega Central CDMX', horaInicio: '08:00', horaFin: '12:00', tecIds: [1, 3], estatus: 'Completado', progreso: 100 },
  { id: 2, folio: 'SRV-2026-002', tipo: 'Mantenimiento', cliente: 'Farma Plus', sucursal: 'Farma Plus Matriz', horaInicio: '09:00', horaFin: '11:00', tecIds: [2], estatus: 'Completado', progreso: 100 },
  { id: 3, folio: 'SRV-2026-003', tipo: 'Externo', cliente: 'Hotel Gran Plaza', sucursal: 'Centro Histórico', horaInicio: '09:00', horaFin: '13:00', tecIds: [5, 11], estatus: 'Completado', progreso: 100 },
  { id: 4, folio: 'SRV-2026-004', tipo: 'Instalación', cliente: 'Castro Corp', sucursal: 'Torre Corporativa', horaInicio: '08:00', horaFin: '18:00', tecIds: [6, 8, 9], estatus: 'En sitio', progreso: 65 },
  { id: 5, folio: 'SRV-2026-005', tipo: 'Visita', cliente: 'Constructora del Valle', sucursal: 'Oficinas Reforma', horaInicio: '14:00', horaFin: '15:30', tecIds: [4], estatus: 'En camino', progreso: 0 },
  { id: 6, folio: 'SRV-2026-006', tipo: 'Mantenimiento', cliente: 'Farma Plus', sucursal: 'Polanco', horaInicio: '14:00', horaFin: '16:00', tecIds: [2], estatus: 'Programado', progreso: 0 },
  { id: 7, folio: 'SRV-2026-007', tipo: 'Instalación', cliente: 'Colegio Montessori', sucursal: 'Campus Norte', horaInicio: '15:00', horaFin: '19:00', tecIds: [1, 7], estatus: 'Programado', progreso: 0 },
  { id: 8, folio: 'SRV-2026-008', tipo: 'Urgencia', cliente: 'Bodega Norte MTY', sucursal: 'Andén 3', horaInicio: '11:00', horaFin: '14:00', tecIds: [3], estatus: 'Retrasado', progreso: 20 },
];

const tecnicosEstatus = [
  { id: 1, semaforo: 'completado', linea: 'Bodegas Alianza — completado 12:00', asistencia: 'puntual' },
  { id: 2, semaforo: 'completado', linea: 'Farma Plus — completado 10:50', asistencia: 'puntual' },
  { id: 3, semaforo: 'retrasado', linea: 'Urgencia Bodega Norte — retrasado 45min', asistencia: 'tarde' },
  { id: 4, semaforo: 'en-camino', linea: 'Constructora del Valle — en camino', asistencia: 'puntual' },
  { id: 5, semaforo: 'completado', linea: 'Hotel Gran Plaza — completado 12:45', asistencia: 'puntual' },
  { id: 6, semaforo: 'en-sitio', linea: 'Castro Corp — en sitio desde 08:00', asistencia: 'puntual' },
  { id: 7, semaforo: 'sin-servicio', linea: 'Próximo: Montessori 15:00', asistencia: 'puntual' },
  { id: 8, semaforo: 'en-sitio', linea: 'Castro Corp — en sitio desde 08:00', asistencia: 'puntual' },
  { id: 9, semaforo: 'en-sitio', linea: 'Castro Corp — en sitio desde 08:00', asistencia: 'tarde' },
  { id: 10, semaforo: 'sin-servicio', linea: 'Sin servicio hoy', asistencia: 'puntual' },
  { id: 11, semaforo: 'completado', linea: 'Hotel Gran Plaza — completado 12:45', asistencia: 'puntual' },
  { id: 12, semaforo: 'falta', linea: 'No se presentó hoy', asistencia: 'falta' },
];

const semaforoCfg = {
  'en-sitio': { color: '#5cd4b0', glow: '0 0 20px #5cd4b040' },
  'en-camino': { color: '#f4a261', glow: '0 0 20px #f4a26140' },
  'retrasado': { color: '#e05c5c', glow: '0 0 20px #e05c5c40' },
  'completado': { color: '#8fb8e8', glow: '0 0 20px #8fb8e840' },
  'sin-servicio': { color: '#555', glow: 'none' },
  'falta': { color: '#ff3b3b', glow: '0 0 20px #ff3b3b40' },
};

const asistCfg = { puntual: '✅', tarde: '⚠️', falta: '❌' };

const alertasInit = [
  { id: 1, msg: 'Omar L. inició servicio a 3km del sitio — Bodega Norte MTY', ts: Date.now() - 120000 },
  { id: 2, msg: 'Felipe C. registró entrada desde dispositivo diferente', ts: Date.now() - 60000 },
];

const horaAMin = (h) => { const p = h.split(':').map(Number); return p[0] * 60 + p[1]; };

function CirculoProgreso({ pct, size, color, tv }) {
  const r = (size - 8) / 2;
  const circ = 2 * Math.PI * r;
  const offset = circ * (1 - pct / 100);
  return (
    <div style={{ position: 'relative', width: size, height: size, flexShrink: 0 }}>
      <svg width={size} height={size} style={{ transform: 'rotate(-90deg)' }}>
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="rgba(255,255,255,0.08)" strokeWidth="4" />
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={color} strokeWidth="4" strokeDasharray={circ} strokeDashoffset={offset} strokeLinecap="round" style={{ transition: 'stroke-dashoffset 1s ease' }} />
      </svg>
      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <span style={{ fontSize: `${size * 0.28}px`, fontWeight: '800', color: '#fff', fontFamily: PP }}>{pct}%</span>
      </div>
    </div>
  );
}

function CentroControl({ onModoTV }) {
  const [hora, setHora] = useState(new Date());
  const [modoTV, setModoTV] = useState(false);
  const [pantalla, setPantalla] = useState(0); // 0 = servicios, 1 = equipo
  const [rotando, setRotando] = useState(true);
  const [progreso, setProgreso] = useState(0);
  const [alertas, setAlertas] = useState(alertasInit);
  const [fade, setFade] = useState(true);
  const [ultimaAct, setUltimaAct] = useState(Date.now());
  const [autoScroll, setAutoScroll] = useState(true);
  const [scrollPausado, setScrollPausado] = useState(false);
  const [flechasVisibles, setFlechasVisibles] = useState(false);
  const scrollRef = useRef(null);
  const pausaTimer = useRef(null);
  const flechaTimer = useRef(null);
  const touchStartX = useRef(0);

  const [width] = useState(window.innerWidth);
  const esCelular = width < 768;
  const fs = modoTV ? 1.25 : 1;

  // Reloj
  useEffect(() => { const t = setInterval(() => setHora(new Date()), 1000); return () => clearInterval(t); }, []);

  // ESC + flechas teclado
  useEffect(() => {
    const h = (e) => {
      if (e.key === 'Escape' && modoTV) { setModoTV(false); if (onModoTV) onModoTV(false); }
      if (e.key === 'ArrowRight') { irA(1); }
      if (e.key === 'ArrowLeft') { irA(0); }
    };
    window.addEventListener('keydown', h);
    return () => window.removeEventListener('keydown', h);
  }, [modoTV, onModoTV]); // eslint-disable-line

  // Mostrar flechas al mover mouse, ocultar después de 3s
  useEffect(() => {
    if (!modoTV) return;
    const h = () => {
      setFlechasVisibles(true);
      if (flechaTimer.current) clearTimeout(flechaTimer.current);
      flechaTimer.current = setTimeout(() => setFlechasVisibles(false), 3000);
    };
    window.addEventListener('mousemove', h);
    return () => { window.removeEventListener('mousemove', h); if (flechaTimer.current) clearTimeout(flechaTimer.current); };
  }, [modoTV]);

  // Rotación automática
  useEffect(() => {
    if (!rotando) return;
    const interval = setInterval(() => {
      setProgreso(prev => {
        if (prev >= 100) {
          setFade(false);
          setTimeout(() => { setPantalla(p => (p + 1) % 2); setFade(true); }, 100);
          return 0;
        }
        return prev + (100 / 60); // 60 segundos
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [rotando]);

  // Refresh datos
  useEffect(() => { const t = setInterval(() => setUltimaAct(Date.now()), 30000); return () => clearInterval(t); }, []);

  // Auto-scroll: scroll to current hour on screen change, then cycle every 45s
  useEffect(() => {
    if (pantalla !== 0 || !scrollRef.current) return;
    // Initial scroll to current time
    const idx = serviciosHoy.findIndex(s => horaAMin(s.horaInicio) >= hora.getHours() * 60);
    if (idx > 0 && scrollRef.current.children[idx]) {
      scrollRef.current.children[idx].scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [pantalla]); // eslint-disable-line

  // Auto-scroll cycling every 45s
  useEffect(() => {
    if (!modoTV || pantalla !== 0 || scrollPausado) return;
    const el = scrollRef.current;
    if (!el) return;
    const t = setInterval(() => {
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 20) {
        el.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        el.scrollBy({ top: el.clientHeight * 0.6, behavior: 'smooth' });
      }
    }, 45000);
    return () => clearInterval(t);
  }, [modoTV, pantalla, scrollPausado]);

  // Pause auto-scroll on user interaction
  const pausarAutoScroll = () => {
    setScrollPausado(true);
    if (pausaTimer.current) clearTimeout(pausaTimer.current);
    pausaTimer.current = setTimeout(() => setScrollPausado(false), 30000);
  };

  // Swipe support
  const onTouchStart = (e) => { touchStartX.current = e.touches[0].clientX; };
  const onTouchEnd = (e) => {
    const diff = e.changedTouches[0].clientX - touchStartX.current;
    if (Math.abs(diff) > 80) {
      if (diff < 0) irA(1);
      else irA(0);
    }
  };

  // Auto-dismiss alertas después de 8 segundos
  useEffect(() => {
    if (alertas.length === 0) return;
    const t = setTimeout(() => setAlertas(prev => prev.slice(1)), 8000);
    return () => clearTimeout(t);
  }, [alertas]);

  const toggleTV = () => { const next = !modoTV; setModoTV(next); if (onModoTV) onModoTV(next); };
  const irA = (p) => { setPantalla(p); setProgreso(0); };

  const nowMin = hora.getHours() * 60 + hora.getMinutes();
  const secsAgo = Math.round((Date.now() - ultimaAct) / 1000);

  const renderHeader = () => (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: `${14 * fs}px ${20 * fs}px`, flexShrink: 0 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: `${10 * fs}px` }}>
        <img src="/Logo Original Cuadrado.png" alt="BeepMX" style={{ width: `${32 * fs}px`, height: `${32 * fs}px` }} />
        <div>
          <div style={{ fontSize: `${14 * fs}px`, fontWeight: '700', color: '#fff' }}>Vista en vivo</div>
          <div style={{ fontSize: `${10 * fs}px`, color: 'rgba(255,255,255,0.4)' }}>Pantalla {pantalla + 1} de 2{!rotando && ' — pausado'}</div>
        </div>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: `${14 * fs}px` }}>
        <div style={{ textAlign: 'right' }}>
          <div style={{ fontSize: `${20 * fs}px`, fontWeight: '800', color: '#fff', letterSpacing: '-0.02em', fontFamily: PP }}>{hora.toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' })}</div>
          <div style={{ fontSize: `${10 * fs}px`, color: 'rgba(255,255,255,0.4)' }}>{hora.toLocaleDateString('es-MX', { weekday: 'long', day: 'numeric', month: 'long' })}</div>
        </div>
        <button onClick={toggleTV} style={{ padding: `${6 * fs}px ${12 * fs}px`, background: modoTV ? 'rgba(224,92,92,0.3)' : 'rgba(255,255,255,0.1)', color: '#fff', border: '1px solid rgba(255,255,255,0.15)', borderRadius: '8px', fontSize: `${10 * fs}px`, fontWeight: '600', cursor: 'pointer', fontFamily: PP }}>
          {modoTV ? 'ESC' : '📺 TV'}
        </button>
      </div>
    </div>
  );

  // PANTALLA 1 — SERVICIOS
  const renderServicios = () => (
    <div ref={scrollRef} onScroll={pausarAutoScroll} style={{ flex: 1, overflowY: 'auto', padding: `0 ${20 * fs}px ${20 * fs}px`, scrollBehavior: 'smooth', WebkitOverflowScrolling: 'touch' }}>
      {serviciosHoy.map(s => {
        const ec = estatusCfg[s.estatus] || estatusCfg['Programado'];
        const tecs = s.tecIds.map(id => tecnicos.find(t => t.id === id)).filter(Boolean);
        const ini = horaAMin(s.horaInicio);
        const fin = horaAMin(s.horaFin);
        const pasado = fin < nowMin;
        const actual = ini <= nowMin && fin >= nowMin;
        const opa = pasado ? 0.4 : actual ? 1 : 0.7;
        const noAtendido = s.estatus === 'No atendido';

        return (
          <div key={s.id} onClick={() => setRotando(false)} style={{
            display: 'flex', alignItems: 'center', gap: `${16 * fs}px`,
            background: `${ec.color}14`,
            borderLeft: `6px solid ${ec.color}`,
            borderRadius: `${12 * fs}px`,
            padding: `${16 * fs}px ${20 * fs}px`,
            marginBottom: `${10 * fs}px`,
            minHeight: `${100 * fs}px`,
            opacity: opa,
            transition: 'opacity 0.5s',
            cursor: 'pointer',
            animation: noAtendido ? 'pulseCard 2s infinite' : 'none',
          }}>
            {/* Hora */}
            <div style={{ minWidth: `${80 * fs}px`, flexShrink: 0 }}>
              <div style={{ fontSize: `${22 * fs}px`, fontWeight: '800', color: '#fff', fontFamily: PP, lineHeight: 1 }}>{s.horaInicio}</div>
              <div style={{ fontSize: `${10 * fs}px`, color: 'rgba(255,255,255,0.4)', marginTop: '4px' }}>a {s.horaFin}</div>
            </div>

            {/* Info */}
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: `${4 * fs}px` }}>
                <BadgeFolio folio={s.folio} style={{ fontSize: `${9 * fs}px` }} />
                <span style={{ fontSize: `${10 * fs}px`, color: 'rgba(255,255,255,0.5)' }}>{tipoIcon[s.tipo] || ''} {s.tipo}</span>
              </div>
              <div style={{ fontSize: `${17 * fs}px`, fontWeight: '700', color: '#fff', fontFamily: PP, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{s.cliente}</div>
              <div style={{ fontSize: `${12 * fs}px`, color: 'rgba(255,255,255,0.5)', marginBottom: `${6 * fs}px` }}>{s.sucursal}</div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                {tecs.slice(0, 4).map((t, i) => <div key={t.id} style={{ width: `${22 * fs}px`, height: `${22 * fs}px`, borderRadius: '50%', background: t.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: `${8 * fs}px`, fontWeight: '700', color: '#fff', marginLeft: i > 0 ? '-4px' : 0, border: '2px solid #0f1923', zIndex: 4 - i }}>{t.ini}</div>)}
                {tecs.length > 4 && <span style={{ fontSize: `${9 * fs}px`, color: 'rgba(255,255,255,0.4)', marginLeft: '4px' }}>+{tecs.length - 4}</span>}
                <span style={{ fontSize: `${10 * fs}px`, color: 'rgba(255,255,255,0.35)', marginLeft: '6px' }}>{tecs.map(t => t.nombre.split(' ')[0]).join(', ')}</span>
              </div>
            </div>

            {/* Progreso + estatus */}
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: `${6 * fs}px`, flexShrink: 0 }}>
              <CirculoProgreso pct={s.progreso} size={Math.round(56 * fs)} color={ec.color} tv={modoTV} />
              <span style={{ padding: `${2 * fs}px ${10 * fs}px`, borderRadius: '8px', background: `${ec.color}30`, color: ec.color, fontSize: `${9 * fs}px`, fontWeight: '700', fontFamily: PP }}>{ec.label}</span>
            </div>
          </div>
        );
      })}
    </div>
  );

  // PANTALLA 2 — EQUIPO
  const renderEquipo = () => (
    <div style={{ flex: 1, overflowY: 'auto', padding: `0 ${20 * fs}px ${20 * fs}px`, scrollBehavior: 'smooth', WebkitOverflowScrolling: 'touch' }}>
      <div style={{ display: 'grid', gridTemplateColumns: esCelular ? 'repeat(2, 1fr)' : `repeat(${modoTV ? 5 : 4}, 1fr)`, gap: `${10 * fs}px` }}>
        {tecnicosEstatus.map(te => {
          const tec = tecnicos.find(t => t.id === te.id);
          if (!tec) return null;
          const sem = semaforoCfg[te.semaforo] || semaforoCfg['sin-servicio'];
          return (
            <div key={te.id} onClick={() => setRotando(false)} style={{
              background: 'rgba(255,255,255,0.04)',
              borderRadius: `${14 * fs}px`,
              padding: `${16 * fs}px`,
              textAlign: 'center',
              cursor: 'pointer',
              border: '1px solid rgba(255,255,255,0.06)',
              position: 'relative',
            }}>
              {/* Asistencia badge */}
              <div style={{ position: 'absolute', top: `${8 * fs}px`, right: `${8 * fs}px`, fontSize: `${14 * fs}px` }}>{asistCfg[te.asistencia] || ''}</div>

              {/* Semáforo grande */}
              <div style={{ width: `${48 * fs}px`, height: `${48 * fs}px`, borderRadius: '50%', background: sem.color, boxShadow: sem.glow, margin: `0 auto ${10 * fs}px`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div style={{ width: `${28 * fs}px`, height: `${28 * fs}px`, borderRadius: '50%', background: tec.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: `${10 * fs}px`, fontWeight: '700', color: '#fff', border: '2px solid rgba(0,0,0,0.2)' }}>{tec.ini}</div>
              </div>

              <div style={{ fontSize: `${13 * fs}px`, fontWeight: '600', color: '#fff', fontFamily: PP, marginBottom: `${4 * fs}px` }}>{tec.nombre.split(' ')[0]}</div>
              <div style={{ fontSize: `${10 * fs}px`, color: 'rgba(255,255,255,0.45)', fontFamily: PP, lineHeight: 1.3, minHeight: `${28 * fs}px` }}>{te.linea}</div>
            </div>
          );
        })}
      </div>
    </div>
  );

  return (
    <div
      onTouchStart={onTouchStart}
      onTouchEnd={onTouchEnd}
      onWheel={pausarAutoScroll}
      style={{ fontFamily: PP, background: '#0f1923', minHeight: modoTV ? '100vh' : '80vh', display: 'flex', flexDirection: 'column', borderRadius: modoTV ? 0 : '16px', ...(modoTV ? { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 99999, height: '100vh', overflow: 'hidden' } : {}) }}>

      <style>{`
        @keyframes pulseCard { 0%,100% { opacity: 0.7; } 50% { opacity: 1; } }
      `}</style>

      {renderHeader()}

      {/* Contenido con fade — scrollable */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', opacity: fade ? 1 : 0, transition: 'opacity 0.4s ease', overflow: 'hidden', position: 'relative' }}>
        {pantalla === 0 && renderServicios()}
        {pantalla === 1 && renderEquipo()}

        {/* Flechas de navegación — modo TV */}
        {modoTV && flechasVisibles && (
          <>
            <div onClick={() => irA(0)} style={{ position: 'absolute', left: 0, top: '50%', transform: 'translateY(-50%)', width: '48px', height: '120px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.3)', borderRadius: '0 12px 12px 0', cursor: 'pointer', fontSize: '24px', color: pantalla === 0 ? 'rgba(255,255,255,0.15)' : 'rgba(255,255,255,0.6)', transition: 'opacity 0.3s' }}>{'←'}</div>
            <div onClick={() => irA(1)} style={{ position: 'absolute', right: 0, top: '50%', transform: 'translateY(-50%)', width: '48px', height: '120px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.3)', borderRadius: '12px 0 0 12px', cursor: 'pointer', fontSize: '24px', color: pantalla === 1 ? 'rgba(255,255,255,0.15)' : 'rgba(255,255,255,0.6)', transition: 'opacity 0.3s' }}>{'→'}</div>
          </>
        )}
      </div>

      {/* Alertas flotantes */}
      <div style={{ position: 'fixed', top: `${16 * fs}px`, right: `${16 * fs}px`, zIndex: 100000, display: 'flex', flexDirection: 'column', gap: '8px', maxWidth: '360px' }}>
        {alertas.map(a => (
          <div key={a.id} style={{ background: 'rgba(224,92,92,0.9)', borderRadius: '12px', padding: `${12 * fs}px ${14 * fs}px`, border: '1px solid #ff3b3b', display: 'flex', alignItems: 'center', gap: '10px', animation: 'fadeIn 0.3s ease' }}>
            <span style={{ fontSize: `${18 * fs}px` }}>{'⚠️'}</span>
            <span style={{ fontSize: `${11 * fs}px`, color: '#fff', fontFamily: PP, flex: 1 }}>{a.msg}</span>
            <span onClick={() => setAlertas(prev => prev.filter(x => x.id !== a.id))} style={{ cursor: 'pointer', color: 'rgba(255,255,255,0.6)', fontSize: '14px' }}>{'✕'}</span>
          </div>
        ))}
      </div>

      {/* Footer: navegación + progreso */}
      <div style={{ padding: `${10 * fs}px ${20 * fs}px`, flexShrink: 0 }}>
        {/* Barra de progreso */}
        <div style={{ height: '3px', background: 'rgba(255,255,255,0.06)', borderRadius: '2px', marginBottom: `${8 * fs}px`, overflow: 'hidden' }}>
          <div style={{ height: '100%', width: `${progreso}%`, background: '#5c9adb', borderRadius: '2px', transition: 'width 1s linear' }} />
        </div>

        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          {/* Dots de navegación */}
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            {[0, 1].map(i => (
              <div key={i} onClick={() => irA(i)} style={{ width: pantalla === i ? '24px' : '8px', height: '8px', borderRadius: '4px', background: pantalla === i ? '#5c9adb' : 'rgba(255,255,255,0.2)', cursor: 'pointer', transition: 'all 0.3s' }} />
            ))}
            <button onClick={() => setRotando(!rotando)} style={{ marginLeft: '10px', background: 'none', border: '1px solid rgba(255,255,255,0.15)', borderRadius: '6px', padding: `${3 * fs}px ${10 * fs}px`, fontSize: `${9 * fs}px`, color: 'rgba(255,255,255,0.5)', cursor: 'pointer', fontFamily: PP }}>{rotando ? '⏸ Pausar' : '▶ Reanudar'}</button>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            {modoTV && <span style={{ fontSize: `${9 * fs}px`, color: scrollPausado ? 'rgba(245,158,11,0.6)' : 'rgba(92,154,219,0.5)' }}>{scrollPausado ? '⏸ Scroll pausado' : '▶ Auto-scroll'}</span>}
            <span style={{ fontSize: `${9 * fs}px`, color: 'rgba(255,255,255,0.25)' }}>Actualizado hace {secsAgo}s</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CentroControl;
